import { Pipe, PipeTransform } from '@angular/core';
import { DiningOptionsBehavior, TransactionResult, TransactionState } from '../enums';
import { OrderData } from '../interfaces';

@Pipe({
  name: 'cardOnFile',
})
export class CardOnFilePipe implements PipeTransform {
  private defaultText = 'No Card on File';

  transform(orderData: OrderData): string {
    if (!orderData) {
      return this.defaultText;
    }
    if (orderData.orderDestination.behaviour === DiningOptionsBehavior.TABLE) {
      if (orderData.paid) {
        const needsGratuity = orderData.transactions.find(
          transaction =>
            transaction.state === TransactionState.AUTHORIZED &&
            transaction.result === TransactionResult.APPROVED
        );
        if (needsGratuity) {
          return 'ADD GRATUITY';
        }
        return 'PAID';
      }
      if (orderData.transactions.length) {
        return 'ADD PAYMENT';
      }
      return '';
    }
    if (orderData.paid) {
      return 'PAID';
    }
    if (orderData.cardOnFile) {
      const cardOnFile = orderData.cardOnFile;
      return `${cardOnFile.cardScheme} ${cardOnFile.last4}`;
    }
    if (orderData.guestCardsOnFile?.length) {
      const cardOnFile = orderData.guestCardsOnFile[0];
      return `${cardOnFile.cardScheme} ${cardOnFile.last4}`;
    }
    if (orderData.member) {
      return 'MEMBER';
    }
    return this.defaultText;
  }
}
